
<!--
 * @Description: 班级多条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-12-02 11:13:58
-->
<template>
  <div class="cha-zhao-duo-tiao">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDuoTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">班级</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDuoTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-row style="height: 100%;">
        <el-col :span="11" style="height: 100%">
          <el-container>
            <el-header style="padding:0">
              <!-- 搜索区域 BEGIN -->
              <el-form class="search" :model="dataGrid.parms" @submit.enter.prevent>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item>
                  <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable  @change="initZhuanYe();initLeftList()">
                    <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id"/>
                  </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable  @change="initLeftList()">
                        <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="年级" v-model="dataGrid.parms.njid" clearable filterable  @change="initLeftList()">
                        <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="行政班代码/行政班名称" v-model="dataGrid.parms.keyword" clearable @clear="initLeftList()" @keyup.enter="initLeftList()">
                        <template #suffix>
                          <el-icon class="el-input__icon pointer" @click="initLeftList()"><search /></el-icon>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <!-- 搜索区域 BEGIN -->
            </el-header>
            <el-main style="padding:0">
              <el-table :data="dataGrid.data" border v-loading="dataGrid.loading" height="100%" @selection-change="leftSelectionChange" @row-dblclick="leftRowDblclick">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column label="序号" type="index" width="55" fixed align="center" />
                <el-table-column label="行政办代码" prop="xzbdm" fixed align="center" show-overflow-tooltipopenDuoTiao />
                <el-table-column label="行政班名称" prop="xzbmc" fixed align="center" show-overflow-tooltipopenDuoTiao></el-table-column>
                <el-table-column label="班主任" prop="bzrxm" align="center" show-overflow-tooltip />
                <el-table-column width="55" fixed="right" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button link type="primary" @click.stop="leftRowDblclick(scope.row)">
                      <span class="iconfont icon-youjiantou"></span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
        <el-col :span="2" style="height: 100%">
          <div class="but_group">
            <span class="iconfont icon-shuangjiantouzuo" @click="toLeftClick"></span>
            <span class="iconfont icon-shuangjiantouyou" @click="toRightClick"></span>
          </div>
        </el-col>
        <el-col :span="11" style="height: 100%">
          <el-table :data="rightTableData" border v-loading="dataGrid.loading" height="100%" @selection-change="rightSelectionChange" @row-dblclick="rightRowDblclick">
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column width="55" fixed align="center" show-overflow-tooltip>
              <template #default="scope">
                <el-button link type="primary" :disabled="!scope.row.id" @click.stop="rightRowDblclick(scope.row)">
                  <span class="iconfont icon-zuojiantou"></span>
                </el-button>
              </template>
            </el-table-column>
              <el-table-column label="序号" type="index" width="55" fixed align="center" />
              <el-table-column label="行政办代码" prop="xzbdm" fixed align="center" show-overflow-tooltipopenDuoTiao />
              <el-table-column label="行政班名称" prop="xzbmc" fixed align="center" show-overflow-tooltipopenDuoTiao></el-table-column>
              <el-table-column label="班主任" prop="bzrxm" align="center" show-overflow-tooltip />
          </el-table>
        </el-col>
      </el-row>

      <template #footer>
        <div class="dialog-footer">
          <el-row style="width: 100%">
            <el-col :span="11">
              <pagination :pagination="dataGrid.pagination" @ReturnData="initLeftList" />
            </el-col>
            <el-col :span="2">
            </el-col>
            <el-col :span="11" style="display: flex;align-items: center;justify-content: space-between;">
              <span style="font-size: 14px;">共 {{ rightTableData.length }} 条</span>
              <div class="footer_but">
                <el-button type="primary" @click="savestudent()">选择</el-button>
                <el-button type="info" @click="closeWindow('openDuoTiao', emits, false)">关闭</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadList, actionPost, loadSelect } from '@/api/common.js'
import pagination from '@/components/pagination.vue'

const props = defineProps({
  openDuoTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDuoTiao', 'ReturnData'])

const ids = ref([]) // 已选id
const rightTableData = ref([]) // 右侧列表
const leftMultipleSelection = ref([]) // 左侧多选
const rightMultipleSelection = ref([]) // 右侧多选

const savestudent = () => {
  emits('ReturnData', rightTableData.value)
  closeWindow('openDuoTiao', emits, false)
}
// 双击左侧列表
const leftRowDblclick = (row) => {
  leftMultipleSelection.value.push(row)
  toRightClick()
}
// 双击右侧列表
const rightRowDblclick = (row) => {
  rightMultipleSelection.value.push(row)
  toLeftClick()
}
// 左箭头
const toLeftClick = () => {
  if (rightMultipleSelection.value.length) {
    rightMultipleSelection.value.forEach((element) => {
      dataGrid.value.data.unshift(element)
      rightTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          rightTableData.value.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      ids.value = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    rightMultipleSelection.value = []
  }
}
// 右箭头
const toRightClick = () => {
  if (leftMultipleSelection.value.length) {
    leftMultipleSelection.value.forEach((element) => {
      rightTableData.value.push(element)
      dataGrid.value.data.forEach((e, index) => {
        if (e.id === element.id) {
          dataGrid.value.data.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      ids.value = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    leftMultipleSelection.value = []
  }
}
// 左侧复选框
const leftSelectionChange = (val) => {
  leftMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      leftMultipleSelection.value.push(element)
    })
  }
}
// 右侧复选框
const rightSelectionChange = (val) => {
  rightMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      rightMultipleSelection.value.push(element)
    })
  }
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  multipleSelection: [],
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const initLeftList = async (pageNo, pageSize) => {
  dataGrid.value.parms.notInIDs = ids.value
  loadList({
    url: '/api/v2/pdp/banji/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

const initRightList = async () => {
  rightTableData.value = []
  dataGrid.value.loading = true
  const o = { url: '/api/v2/pdp/banji/list', data: { inIDs: ids.value } }
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    rightTableData.value = res.data || [] // 返回列表
  })
}
// 加载 系部 下拉框
const xbData = ref()
// 加载 专业 下拉框
const zyData = ref()
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: {
      xbid: dataGrid.value.parms.xbid || undefined,
      order: 'zybh',
      sort: 'asc'
    }
  })
}

// 加载 年级 下拉框
const njData = ref()

watch(
  () => props.openDuoTiao,
  () => {
    if (props.openDuoTiao) {
      dataGrid.value.parms = props.row
      loadSelect({ url: '/api/v2/xiaoneijigou/listxibu', data: xbData, order: 'jgh', sort: 'asc' })
      loadSelect({ url: '/api/v2/pdp/nianji/list', data: njData, order: 'njdm', sort: 'asc' })
      ids.value = props.row.ids || []
      initZhuanYe()
      initLeftList()
      initRightList()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.filter-item) {
  width: 150px;
}
.search {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-button {
    margin: 0;
  }
}
:deep(.el-radio__label) {
  display: none;
}
:deep(.el-tabs__content) {
  display: none;
}
.el-tabs {
  height: 55px;
}
:deep(.but_group) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
.e-row {
  height: 100%;
}
</style>
